export default __webpack_public_path__ + "static/media/railway_alert_black_24dp.26311fd7.svg";